import { colors, Typography } from '@mui/material';
import React from 'react';
import Employee from '../components/employee/Empolyee'

const EmployeePage = () => {

  return (
    <>
        <Employee />
    </>
  )
}

export default EmployeePage
